export const dir = require("./dir_2x.png");
export const eu = require("./eu_2x.png");
export const ltu = require("./ltu_2x.png");
export const nbtn = require("./nbtn_2x.png");
export const vbtn = require("./vbtn_2x.png");
